import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart, CreditCard, ShieldCheck, FileText, Gift } from 'lucide-react';
export function PurchaseSection() {
  const handlePurchase = () => {
    window.location.href = 'https://checkout.rosetadigital.com/cart/46024210448537:1';
  };
  return <section className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-93">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-5" data-id="element-94">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-[#4a7c2c] rounded-full blur-3xl" data-id="element-95"></div>
        <div className="absolute top-1/2 right-0 w-64 h-64 bg-[#8bc34a] rounded-full blur-3xl" data-id="element-96"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-97">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl border-2 border-[#4a7c2c] overflow-hidden" data-id="element-98">
          <div className="bg-[#2d5016] text-white py-4 text-center" data-id="element-99">
            <h2 className="text-xl md:text-2xl font-bold flex items-center justify-center gap-2" data-id="element-100">
              ⏳ Oferta por tiempo limitado
            </h2>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-101">
            <div className="flex flex-col items-center justify-center mb-8" data-id="element-102">
              <span className="text-xl text-[#666666] line-through mb-2" data-id="element-103">
                Antes: $49.900 ARS
              </span>
              <div className="flex items-center gap-3" data-id="element-104">
                <span className="text-5xl md:text-6xl font-bold text-[#2d5016]" data-id="element-105">
                  $19.990
                </span>
                <span className="text-xl font-bold text-[#4a7c2c]" data-id="element-106">ARS</span>
              </div>
              <span className="inline-block bg-[#ffebee] text-[#d32f2f] px-3 py-1 rounded-full text-sm font-bold mt-4" data-id="element-107">
                🔥 Ahorrás $29.910 hoy
              </span>
            </div>

            <div className="grid md:grid-cols-2 gap-4 max-w-lg mx-auto mb-10 text-left" data-id="element-108">
              <div className="flex items-center gap-3 text-[#1a1a1a]" data-id="element-109">
                <CreditCard className="w-5 h-5 text-[#4a7c2c]" data-id="element-110" />
                <span data-id="element-111">Hasta 3 cuotas fijas</span>
              </div>
              <div className="flex items-center gap-3 text-[#1a1a1a]" data-id="element-112">
                <ShieldCheck className="w-5 h-5 text-[#4a7c2c]" data-id="element-113" />
                <span data-id="element-114">Compra 100% segura</span>
              </div>
              <div className="flex items-center gap-3 text-[#1a1a1a]" data-id="element-115">
                <ShoppingCart className="w-5 h-5 text-[#4a7c2c]" data-id="element-116" />
                <span data-id="element-117">Entrega inmediata en PDF</span>
              </div>
              <div className="flex items-center gap-3 text-[#1a1a1a]" data-id="element-118">
                <ShieldCheck className="w-5 h-5 text-[#4a7c2c]" data-id="element-119" />
                <span data-id="element-120">Acceso de por vida</span>
              </div>
              <div className="flex items-center gap-3 text-[#1a1a1a]" data-id="element-121">
                <FileText className="w-5 h-5 text-[#4a7c2c]" data-id="element-122" />
                <span data-id="element-123">📖 Guía Completa para Hacer Esquejes (PDF)</span>
              </div>
              <div className="flex items-center gap-3 text-[#1a1a1a]" data-id="element-124">
                <Gift className="w-5 h-5 text-[#d32f2f]" data-id="element-125" />
                <span data-id="element-126">🎁 5 Bonos Exclusivos (GRATIS)</span>
              </div>
            </div>

            <div className="flex flex-col items-center gap-4" data-id="element-127">
              <span className="text-2xl font-bold text-[#1a1a1a]" data-id="element-128">$19.990</span>
              <motion.button whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} onClick={handlePurchase} className="w-full max-w-md bg-[#4a7c2c] text-white text-xl md:text-2xl font-bold py-5 px-8 rounded-full shadow-xl hover:bg-[#3d6624] transition-colors flex items-center justify-center gap-3" data-id="element-129">
                Comprar ahora
                <ShoppingCart className="w-6 h-6" data-id="element-130" />
              </motion.button>
              <p className="text-sm text-[#666666] mt-2" data-id="element-131">
                Listo para usar hoy mismo.
              </p>
            </div>
          </div>

          <div className="bg-[#f1f8e9] p-4 text-center text-sm text-[#666666] border-t border-[#e8f5e9]" data-id="element-132">
            <p data-id="element-133">Garantía de satisfacción. Si no aprendés, no pagás.</p>
          </div>
        </motion.div>
      </div>
    </section>;
}